export const QueryKeys = {
  Bets: 'bets',
  ProofPoints: 'proofPoints',
  Projects: 'projects',
  Persons: 'persons',
  Categories: 'categories',
} as const

export type QueryKey = (typeof QueryKeys)[keyof typeof QueryKeys]
